module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/miki-ee0b7cdbd9ab15899db639195fe2d927.webp";